import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

const ClosureGrid = ({ closures, defaultColDef}) => {
    
    const columns=[
        {field:'StreetName', headerName: 'Street'},
        {field:'FeatureType', headerName: 'Type'}
        
      ]
    
  return (
    
    <div className='ag-theme-alpine' >
      <AgGridReact columnDefs={columns} 
        rowData={closures} 
        defaultColDef={defaultColDef}/>
    </div>
    
  )
}

export default ClosureGrid